import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  cardItem: {
    backgroundColor: theme.colors.dark.midnightBlue,
    overflow: 'auto',
    position: 'relative',
  },
  content: {
    padding: '20px 15px 0',
    color: '#fff',
  },
  serviceItemsList: {
    margin: 0,
    marginBottom: 20,
    paddingLeft: 20,
    fontWeight: 900,
  },
  tip: {
    backgroundColor: theme.colors.orange.orange,
    color: '#FFF',
    position: 'absolute',
    borderRadius: '4px',
    fontWeight: 'bold',
    margin: '15px 15px',
    right: 0,
    padding: '5px',
    '& span': {
      backgroundColor: '#FFC056',
      borderRadius: '2rem',
      width: '1rem',
      height: '1rem',
      paddingLeft: '3px',
      lineHeight: '1rem',
      display: 'inline-block',
      marginRight: '0.5rem',
    },
  },
}));
